import {PageTitle} from "../../../Components/Landmarks";
import type { ContextProps } from '../../../types';
import {useEffect, useState} from "react";
import {ShippingLocationAddForm} from "./ShippingLocationAddForm";
import {shippingLocationModel} from "./shippingLocationFactory";
import {shippingLocationApi} from "./shippingLocationApi";
import {orderRequestApi} from "../OrderRequest/orderRequestApi";
import {isFimcAdmin} from "../../../Utilities/LocalStorage/storageUtilities";

export const ShippingLocationAddContainer = ({
                                                 handleApiCall,
                                                 handleReturnRedirect,
                                             }: ContextProps) => {
    const handleReturn = () => handleReturnRedirect();
    const [shippingLocations, setShippingLocations] = useState<Record<string, unknown>>();


    const handleSaveShippingLocation = async (shippingLocationDetails: Record<string, unknown>) => {
        const shippingLocation = shippingLocationModel(shippingLocationDetails);

        if (!shippingLocationDetails.shippingLocationId) {
            handleApiCall(() => shippingLocationApi.addShippingLocation(shippingLocation), () => {
                handleReturn();
            });
        }
        else{
            handleApiCall(() => shippingLocationApi.editShippingLocation(shippingLocation), () => {
                handleReturn();
            });

        }
    };

    const setShippingLocationResult = (results: Record<string, unknown>) => {
        setShippingLocations(results);
    }

    useEffect(() => {
        const getShippingLocations = () => {
            handleApiCall(() => orderRequestApi.getShippingLocations(), setShippingLocationResult);
        }

        if (!shippingLocations && isFimcAdmin()){
            getShippingLocations();
        }

    }, []);



    return <>
        <PageTitle h1={`Add Shipping Location`}/>
        <ShippingLocationAddForm
            handleSaveShippingLocation={handleSaveShippingLocation}
            handleReturn={handleReturn}
            shippingLocations={shippingLocations}
        />

    </>;
};
